/* ==========================================================================
   OSERE — Etapas: la etapa activa se resalta con el scroll.

   POR QUÉ SCROLL Y NO `IntersectionObserver`. Los dos resuelven el problema,
   pero el panel de navegador con el que se verifica este proyecto corre con
   `visibilityState: 'hidden'` y ahí NINGÚN observador dispara — mientras que
   `dispatchEvent(new Event('scroll'))` sí invoca a este manejador de forma
   síncrona. Con IO esta sección no se podría comprobar hasta tenerla delante
   en un navegador visible, y en este proyecto lo que no se puede medir acaba
   mordiendo. Además, en la medición de partida no hay control ninguno: sus
   ítems van con `cursor:auto`, `tabIndex:-1` y sin `role`.

   LA REGLA ES UNA FUNCIÓN PURA DE LA POSICIÓN DE SCROLL:
   activa = la ÚLTIMA etapa cuyo ancla ya cruzó la línea de barrido.
   Se puede llamar sin hacer scroll (`seccion._osEtapas.calcular(y)`), que es lo
   que permite barrer la sección entera en una prueba.

   TRES FASES SEPARADAS, y la separación ES el rendimiento:
   medir (solo lecturas) · decidir (aritmética) · pintar (solo escrituras).
   Ni un `getBoundingClientRect` por frame.

   🚨 EL ESTADO ATENUADO LO ENCIENDE ESTE ARCHIVO, NUNCA LA HOJA. Si el
   `opacity` viviera en el CSS, bastaría con que este script no llegara a
   ejecutarse —bloqueado, error de red, un fallo de otra sección— para dejar
   tres de cada cuatro etapas apagadas de forma permanente. Poniendo
   `data-os-et-listo` desde aquí, la ausencia de JS significa «se ve todo».
   Mismo criterio que el reveal del pie y que el vídeo del hero.
   ========================================================================== */
(function () {
  'use strict';

  var monturas = [];

  function montar(seccion) {
    if (seccion.hasAttribute('data-os-et-montado')) return;
    seccion.setAttribute('data-os-et-montado', '');

    var etapas = Array.prototype.slice.call(seccion.querySelectorAll('[data-os-et-etapa]'));
    if (!etapas.length) return;

    var rejilla = seccion.querySelector('.os-et__medios');
    var videos = rejilla ? Array.prototype.slice.call(rejilla.querySelectorAll('[data-os-et-src]')) : [];

    var factor = (parseInt(seccion.getAttribute('data-barrido'), 10) || 50) / 100;
    var anclas = [];
    var actual = -1;
    var videoEncendido = false;
    var pendiente = false;

    /* --- 1. medir: SOLO lecturas, y solo al montar, al redimensionar y al
       terminar de cargar (una imagen diferida por encima de la sección mueve
       todo lo de abajo). --------------------------------------------------- */
    function medir() {
      var y = window.pageYOffset || document.documentElement.scrollTop;
      anclas = etapas.map(function (el) {
        return el.getBoundingClientRect().top + y;
      });
    }

    /* --- 2. decidir: aritmética pura, sin tocar el DOM. La zona muerta evita
       el parpadeo cuando el scroll tiembla justo sobre un ancla. ----------- */
    function calcular(y) {
      var linea = y + window.innerHeight * factor;
      var i = 0;
      for (var k = 0; k < anclas.length; k++) {
        if (anclas[k] <= linea + 8) i = k;
      }
      return i;
    }

    /* --- 3. pintar: SOLO escrituras. ------------------------------------- */
    function pintar(i) {
      if (i === actual) return;
      if (actual >= 0 && etapas[actual]) etapas[actual].removeAttribute('data-activa');
      if (etapas[i]) etapas[i].setAttribute('data-activa', '');
      actual = i;
    }

    function videosDentro(dentro) {
      if (dentro === videoEncendido) return;
      videoEncendido = dentro;
      videos.forEach(function (v) {
        if (dentro) {
          var src = v.getAttribute('data-os-et-src');
          if (src && v.getAttribute('src') !== src) {
            v.src = src;
            var p = v.play();
            if (p && p.catch) p.catch(function () { /* autoplay bloqueado: queda el póster */ });
          }
        } else {
          v.pause();
          v.removeAttribute('src');
          v.load();
        }
      });
    }

    function paso() {
      pendiente = false;
      var y = window.pageYOffset || document.documentElement.scrollTop;
      pintar(calcular(y));
      if (rejilla) {
        var c = rejilla.getBoundingClientRect();
        videosDentro(c.bottom > 0 && c.top < window.innerHeight);
      }
    }

    /* En una pestaña oculta `requestAnimationFrame` no se ejecuta nunca, así que
       ahí se llama de forma síncrona. Sin esto la sección no se puede verificar
       con el panel del proyecto — y con el cerrojo puesto, el primer frame que
       no llega deja `pendiente` en true para siempre. */
    function pedir() {
      if (pendiente) return;
      if (document.visibilityState === 'hidden') { paso(); return; }
      pendiente = true;
      requestAnimationFrame(paso);
    }

    window.addEventListener('scroll', pedir, { passive: true });
    window.addEventListener('resize', function () { medir(); pedir(); }, { passive: true });
    window.addEventListener('load', function () { medir(); pedir(); });

    if (typeof ResizeObserver === 'function') {
      var ro = new ResizeObserver(function () { medir(); pedir(); });
      ro.observe(seccion);
    }

    medir();
    /* El atenuado se enciende AQUÍ y no antes: hasta esta línea la sección se ve
       entera a plena tinta. */
    seccion.setAttribute('data-os-et-listo', '');
    paso();

    /* Asa para verificar sin hacer scroll de verdad. */
    seccion._osEtapas = {
      medir: medir,
      calcular: calcular,
      anclas: function () { return anclas.slice(); },
      activa: function () { return actual; }
    };
    monturas.push(seccion);
  }

  function init(raiz) {
    var ambito = raiz || document;
    Array.prototype.slice
      .call(ambito.querySelectorAll('[data-os-etapas]'))
      .forEach(montar);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); }, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
